import React, { useState, useContext, useEffect } from 'react'
/* Mattlib */
import Dropdown from './Dropdown';
import RadioButtonsGroup from './RadioButtonsGroup'
import TextFields_Outlined from './TextFields_Outlined';
import ProgressBar from './ProgressBar';
import Modal_Loading from './Modal_Loading'
/* Button */
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';

/* Fade in */
import FadeIn from './FadeIn'
/* Date Picker 
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";*/
/* Data JSON */
import languages from '../data/languages.json'
import schools from '../data/schools.json'
import districts from '../data/districts.json'

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import ColumnStatus from './ColumnStatus'

import ContentContext from './ContentContext'

import { useDispatch, useSelector } from 'react-redux'
import {backToInitialValuesUpdated} from '../redux/slices/translationSlice'
import {backToInitialValuesUpdated_int} from '../redux/slices/interpretationSlice'
import {backToInitialValuesUpdated_bil} from '../redux/slices/assessmentSlice'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import CustomizedSnackbars from './CustomizedSnackbars';

import SignatureUpload from './SignatureUpload'
import SignatureUpload_2Fields_1FilePer from './SignatureUpload_2Fields_1FilePer'

import axios from 'axios'

// Context
import { useTranslation, useTranslationUpdate} from './TranslationContexts/TranslationDataContext'
import { ExpandLessSharp, SchoolOutlined } from '@material-ui/icons';

const ApprovalContent_Assessments = ({ handleProgressBarChange, handleContinueButton }) => {
  const { contentState, setContentState } = useContext(ContentContext)
  const [canProceed, setCanProceed] = useState(false);
  const [column1Complete, setColumn1Complete] = useState(false)

  const dispatch = useDispatch();
  const translationState = useSelector((state) => state.translation);
  const interpretationState = useSelector((state) => state.interpretation);
  const assessmentState = useSelector((state) => state.assessment);

  // Files fields
  const [intakeFile, setIntakeFile] = useState('')
  const [consentToEvalAttachedFile, setConsentToEvalAttachedFile] = useState('')
  const [priorWrittenNoticeAttachedFile, setPriorWrittenNoticeAttachedFile] = useState('')
  const [homeLangQuestAttachedFile, setHomeLangQuestAttachedFile] = useState('')

  const [docToAccessFiles_bil, setDocToAccessFiles_bil] = useState([{}])
  const [consentToEvalAttachedFiles_bil, setConsentToEvalAttachedFiles_bil] = useState([{}])
  const [priorWrittenNoticeAttachedFiles_bil, setPriorWrittenNoticeAttachedFiles_bil] = useState([{}])
  const [homeLangQuestAttachedFiles_bil, setHomeLangQuestAttachedFiles_bil] = useState([{}])
  const [docToAccessFiles_bilRunOut, setDocToAccessFiles_bilRunOut] = useState(0)
  
  const dataForQB = useTranslation()
  // TESTING STUDENT TESTING DATA
  const setDataForQB = useTranslationUpdate()
  var jsonPOSTdata = null;
  var DEBUG_RESPONSE;
  var DEBUG_RESPOSNE_STATUS;
  var debugDOdata = {
      "to": "bs6t8eey7",
      "data": [
        {
          "6": {
            "value": ""
          },
          "7": {
            "value": ""
          },
          "8": {
            "value": ""
          },
          "11": {
            "value": ""
          }
        }
      ],
      "fieldsToReturn": [
        3
      ]
  }
  var ridDOdata = {
    "from": "brvxc3bp2",
    "select": [
      3
    ],
    "where": "{3.GT.'0'}",
    "sortBy": [
      {
        "fieldId": 3,
        "order": "DESC"
      }
    ],
    "groupBy": [
      {
        "fieldId": 3,
        "grouping": "equal-values"
      }
    ],
    "options": {
      "skip": 0,
      "top": 0,
      "compareWithAppLocalTime": false
    }
  }
  var interTestingPOSTdata = null;
  var testPostData = null;
  var districtId = 0;
  var schoolId = 0;
  // Dates
  var finalDOB_bil;
  var finalCSEDate_bil;
  //var finalStudentEnterSchoolDate_bil;
  var finalPhysicalExamDate_bil;
  // Files
  var finalFile;
  var finalFileExt;
  var finalConsentToEvalFile;
  var finalConsentToEvalFileExt;
  var finalPriorWrittenNoticeFile;
  var finalPriorWrittenNoticeFileExt;
  var finalHomeLanguageQuestFile;
  var finalHomeLanguageQuestFileExt;
  var finalNonVerbalSecDiagnosedFile;
  var finalNonVerbalSecDiagnosedFileExt;

  // For enabling/disabling the submit button
  let showSaveBtn = true;

  // Universal all filled out for submit button
  var u_allFilledOut = false;

  // These are for the loading snack
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [loadingSnack, setLoadingSnack] = useState(false);
  const [loadingSnackClass, setLoadingSnackClass] = useState("success");
  
  // Which file attachment fields will we use
  const [consentAttach, setConsentAttach] = useState(dataForQB.consentToEvalAttached_bill);
  const [priorWrittenAttach, setPriorWrittenAttach] = useState(dataForQB.priorWrittenNoticeAttached_bil);
  const [howLangAttach, setHowLangAttach] = useState(dataForQB.homeLangQuestAttached_bil);
  //const [nonVerbAttach, setNonVerbAttachl] = useState(dataForQB.nonVerbSecDiagnosed_bil);
  
  async function interpretationTestingsPOST() {
    var tempData = [
      {
        "6": { "value": "Name 1" },
        "7": { "value": "Pre-K" },
        "8": { "value": "IEP 1" }
      },
      {
        "6": { "value": "Name 2" },
        "7": { "value": "K" },
        "8": { "value": "IEP 2" }
      }
    ]

    interTestingPOSTdata = {
      "to": "brtudcea2",
      "data": tempData,
      "fieldsToReturn": [
        3,
        4
      ]
    }
  
}

  function getJsonValueByName(jsonData, name){
    let valToReturn = "0";
    let l = Object.keys(jsonData).length;
    for (var i = 0; i < l; i++) {
      
      if (name == jsonData[i].name)
      {
        valToReturn = jsonData[i].id//.toString();
        //console.log("FOUND " + name + " = " + jsonData[i].id)
        break;
      }
      //else console.log(name + " NO MATCH " + jsonData[i].name)
    }
    return valToReturn
  }

  async function finalizeJSONAndCallAPS() {
    ///////////////////////////////////////////////////////////////////////////
    // Dates
    ///////////////////////////////////////////////////////////////////////////
    // DOB //
    /*var day = dataForQB.DOB_bil.getDate();
    //alert(day<10)
    var finalDay = day < 10 ? "0"+day.toString() : day.toString();
    var month = parseInt(dataForQB.DOB_bil.getMonth())+1;
    var finalMonth = month < 10 ? "0"+month.toString() : month.toString();
    var year = dataForQB.DOB_bil.getFullYear();
    var finalDate = year+"-"+finalMonth+"-"+finalDay
    finalDOB_bil = finalDate;

    // CSE Date //
    var day = dataForQB.CSEDate_bil.getDate();
    //alert(day<10)
    var finalDay = day < 10 ? "0"+day.toString() : day.toString();
    var month = parseInt(dataForQB.CSEDate_bil.getMonth())+1;
    var finalMonth = month < 10 ? "0"+month.toString() : month.toString();
    var year = dataForQB.CSEDate_bil.getFullYear();
    var finalDate = year+"-"+finalMonth+"-"+finalDay
    finalCSEDate_bil = finalDate;*/

    // studentEnterSchoolDate_bil // - as per Menia - could be put in as a grade so need to be a text field (6/29/22)
    //var day = dataForQB.studentEnterSchoolDate_bil.getDate();
    //var finalDay = day < 10 ? "0"+day.toString() : day.toString();
    //var month = parseInt(dataForQB.studentEnterSchoolDate_bil.getMonth())+1;
    //var finalMonth = month < 10 ? "0"+month.toString() : month.toString();
    //var year = dataForQB.studentEnterSchoolDate_bil.getFullYear();
    //var finalDate = year+"-"+finalMonth+"-"+finalDay
    //finalStudentEnterSchoolDate_bil = finalDate;

    /*
    // physicalExamDate_bil //
    var day = dataForQB.physicalExamDate_bil.getDate();
    //alert(day<10)
    var finalDay = day < 10 ? "0"+day.toString() : day.toString();
    var month = parseInt(dataForQB.physicalExamDate_bil.getMonth())+1;
    var finalMonth = month < 10 ? "0"+month.toString() : month.toString();
    var year = dataForQB.physicalExamDate_bil.getFullYear();
    var finalDate = year+"-"+finalMonth+"-"+finalDay
    finalPhysicalExamDate_bil = finalDate;*/
    ///////////////////////////////////////////////////////////////////////////


    // Convert strings to their QB rids
    districtId = getJsonValueByName(districts, assessmentState.districtDropdown_bil)
    schoolId = getJsonValueByName(schools, assessmentState.schoolDropdown_bil)
    
    /* FOR TESTING ONLY
    finalDOB_bil = "2022-06-06";
    finalCSEDate_bil = "2022-06-06";
    finalStudentEnterSchoolDate_bil = "2022-06-06";
    finalPhysicalExamDate_bil = "2022-06-06";*/

    // Will need to extract just the value out of this and not the entire object
    //let temp = dataForQB.dateDue.value;//.toString();
    //console.log("TEEEEEEEEEEEEEEEST: " + temp);
    
    dataForQB.approveradditionalFile_int = "";
    //console.log(intakeFile)
    //var st = intakeFile.indexOf("/");
    //var en = intakeFile.indexOf(";");
    //var startIndex = intakeFile.indexOf(";base64,");
    //finalFile = intakeFile.substring(startIndex+8, intakeFile.length);
    //finalFileExt = intakeFile.substring(st+1, en)

    //setIntakeFile(finalIntakeFile);
    //setIntakeFile(btoa('iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=='))
    jsonPOSTdata = {
      "to": "brvxc3bp2",
      "data": [
        {
          "6": { "value": assessmentState.studentFirstName_bil },
          "7": { "value": assessmentState.studentLastName_bil },
          "8": { "value": assessmentState.countryOfOrigin_bil },
          "9": { "value": assessmentState.DOB_bil },
          "10": { "value": assessmentState.gender_bil },
          "11": { "value": assessmentState.yearsInUS_bil },
          "12": { "value": assessmentState.grade_bil },
          "13": { "value": assessmentState.childResidesWith_bil },
          "14": { "value": assessmentState.mfg1_bil },
          "15": { "value": assessmentState.mfgName1_bil },
          "16": { "value": assessmentState.mfg2_bil },
          "17": { "value": assessmentState.mfgName2_bil },
          "18": { "value": assessmentState.childsResidesWithOther_bil },
          "104": { "value": assessmentState.homeAddress_bil },
          "26": { "value": assessmentState.homeNum_bil },
          "27": { "value": assessmentState.workNum_bil },
          "28": { "value": assessmentState.cellNum_bil },
          "29": { "value": assessmentState.nativeLanguage_bil },
          "30": { "value": assessmentState.nativeLanguageOther_bil },
          "31": { "value": districtId }, //
          "33": { "value": schoolId }, //
          "35": { "value": assessmentState.psychologistName_bil },
          "36": { "value": assessmentState.psychologistEmail_bil },
          "37": { "value": assessmentState.speechPathologistName_bil },
          "38": { "value": assessmentState.speechPathologistEmail_bil },
          "39": { "value": assessmentState.districtContactName_bil },
          "40": { "value": assessmentState.districtContactTitle_bil },
          "41": { "value": assessmentState.districtContactAddress_bil },
          "42": { "value": assessmentState.districtContactPhone_bil },
          "43": { "value": assessmentState.districtContactEmail_bil },
          "331": { "value": assessmentState.approverName_bil },
          "332": { "value": assessmentState.approverTitle_bil },
          "333": { "value": assessmentState.approverEmail_bil },
          "44": { "value": assessmentState.reason_bil },
          "45": { "value": assessmentState.alreadyClassified_bil },
          "46": { "value": assessmentState.classification_bil },
          "47": { "value": assessmentState.consentToEvalAttached_bill },
          "48": { "value": assessmentState.priorWrittenNoticeAttached_bil },
          "49": { "value": assessmentState.homeLangQuestAttached_bil },
          "50": { "value": assessmentState.nonVerbSecDiagnosed_bil },
          "51": { "value": assessmentState.studentEnterSchoolDate_bil },
          "52": { "value": assessmentState.nameOfOtherSchoolAttended_bil },
          "53": { "value": assessmentState.typesOfEvals_bil },
          "54": { "value": assessmentState.diagnosedCondition_bil },
          "55": { "value": assessmentState.diagnosedConditionText_bil },
          "56": { "value": assessmentState.services_bil },
          "57": { "value": assessmentState.generalHealth_bil },
          "58": { "value": assessmentState.generalHealthText_bil },
          "59": { "value": assessmentState.medication_bil },
          "60": { "value": assessmentState.medicationText_bil },
          "61": { "value": assessmentState.wearsGlasses_bil },
          "62": { "value": assessmentState.wearsGlassesText_bil },
          "63": { "value": assessmentState.pedRestrictions_bil },
          "64": { "value": assessmentState.pedRestrictionsText_bil },
          "65": { "value": assessmentState.physicalExamDate_bil },//
          "66": { "value": assessmentState.h_freq_audiology_bil },
          "67": { "value": assessmentState.h_indv_audiology_bil },
          "68": { "value": assessmentState.h_freq_visTherapy_bil },
          "69": { "value": assessmentState.h_indv_visTherapy_bil },
          "70": { "value": assessmentState.h_freq_resourceRoom_bil },
          "71": { "value": assessmentState.h_indv_resourceRoom_bil },
          "72": { "value": assessmentState.h_freq_counseling_bil },
          "73": { "value": assessmentState.h_indv_counseling_bil },
          "74": { "value": assessmentState.h_freq_speechLang_bil },
          "75": { "value": assessmentState.h_indv_speechLang_bil },
          "76": { "value": assessmentState.h_freq_physTherapy_bil },
          "77": { "value": assessmentState.h_indv_physTherapy_bil },
          "78": { "value": assessmentState.h_freq_occTherapy_bil },
          "79": { "value": assessmentState.h_indv_occTherapy_bil },
          "80": { "value": assessmentState.i_freq_Reading_bil },
          "81": { "value": assessmentState.i_indv_Reading_bil },
          "82": { "value": assessmentState.i_freq_AISMath_bil },
          "83": { "value": assessmentState.i_indv_AISMath_bil },
          "84": { "value": assessmentState.i_freq_AAtL_bil },
          "85": { "value": assessmentState.i_indv_AAtL_bil },
          "86": { "value": assessmentState.i_freq_AdjAssign_bil },
          "87": { "value": assessmentState.i_indv_AdjAssign_bil },
          "88": { "value": assessmentState.i_freq_schedAdj_bil },
          "89": { "value": assessmentState.i_indv_schedAdj_bil },
          "90": { "value": assessmentState.i_freq_indvProgBasedOnSkill_bil },
          "91": { "value": assessmentState.i_indv_indvProgBasedOnSkill_bil },
          "92": { "value": assessmentState.i_freq_speechImprov_bil },
          "93": { "value": assessmentState.i_indv_speechImprov_bil },
          "94": { "value": assessmentState.i_freq_tutoring_bil },
          "95": { "value": assessmentState.i_indv_tutoring_bil },
          "96": { "value": assessmentState.i_freq_consulServices_bil },
          "97": { "value": assessmentState.i_indv_consulServices_bil },
          "98": { "value": assessmentState.i_other_bil },
          "99": { "value": assessmentState.areas_bil },
          "100": { "value": assessmentState.addConcerns_bil },
          "101": { "value": assessmentState.suspDetails_bil },
          "421": { "value": assessmentState.currentTeacherName_bil},
          "422": { "value": assessmentState.currentTeacherEmail_bil},
          "155": { "value": assessmentState.CSEDate_bil}, //
          "341": { "value": assessmentState.notes_bil},
          "436": { "value": assessmentState.typesOfEvals_other_bil},
          "475": { "value": assessmentState.coser_bil},
        }
      ],
      "fieldsToReturn": [
        3,
        4
      ]
    }

    // Get prefix for file attachment names
    let NEXT_RID_CALL = await axios.post(
      'https://api.quickbase.com/v1/records/query',
      ridDOdata,
      {
        headers: {
          'QB-Realm-Hostname': 'nassauboces.quickbase.com',
          'Authorization': 'QB-USER-TOKEN b3m32i_br69_0_c89ecind3d9jnncsv8a38b7gj33s'
        }
      }
    ).then((response) => {
      return response.data.data[0][3].value;
    }, (error) => {
      return "errorFetchingRID";
    });
    let NEXT_RID = parseInt(NEXT_RID_CALL)+1;
    let offset = 0;
    const currDate = new Date();
    if (currDate.getMonth()>5) offset = 1;
    const CURR_YR = (parseInt(new Date().getFullYear().toString().substring(2,4))+offset).toString();
    //CURR_YR = "23";
    const FILE_PREFIX = CURR_YR + "-" + NEXT_RID + "B-";
    

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Add up to 10 file attachment fields
    /*let noBilFiles = false;
      try{
        if(docToAccessFiles_bil[0] && docToAccessFiles_bil[0].name === "undefined" || docToAccessFiles_bil[0].name === undefined) noBilFiles = true;
        else noBilFiles = false;
      }
      catch {noBilFiles = true}

    // If there's none of these then no need to check any of them
    if (!noBilFiles){*/
          // Doc 1 //
      if (docToAccessFiles_bil.length>0 && docToAccessFiles_bil[0].content){
        var st = docToAccessFiles_bil[0].content.indexOf("/");
        var en = docToAccessFiles_bil[0].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[0].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[0].content.substring(startIndex+8, docToAccessFiles_bil[0].content.length)
        jsonPOSTdata.data[0][186] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[0].name,
            "data": tempFile
          }
        };
      }

      // Doc 2 //
      if (docToAccessFiles_bil.length>1 && docToAccessFiles_bil[1].content){
        var st = docToAccessFiles_bil[1].content.indexOf("/");
        var en = docToAccessFiles_bil[1].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[1].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[1].content.substring(startIndex+8, docToAccessFiles_bil[1].content.length)
        jsonPOSTdata.data[0][187] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[1].name,
            "data": tempFile
          }
        };
      }

      // Doc 3 //
      if (docToAccessFiles_bil.length>2 && docToAccessFiles_bil[2].content){
        var st = docToAccessFiles_bil[2].content.indexOf("/");
        var en = docToAccessFiles_bil[2].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[2].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[2].content.substring(startIndex+8, docToAccessFiles_bil[2].content.length)
        jsonPOSTdata.data[0][188] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[2].name,
            "data": tempFile
          }
        };
      }

      // Doc 4 //
      if (docToAccessFiles_bil.length>3 && docToAccessFiles_bil[3].content){
        var st = docToAccessFiles_bil[3].content.indexOf("/");
        var en = docToAccessFiles_bil[3].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[3].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[3].content.substring(startIndex+8, docToAccessFiles_bil[3].content.length)
        jsonPOSTdata.data[0][189] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[3].name,
            "data": tempFile
          }
        };
      }

      // Doc 5 //
      if (docToAccessFiles_bil.length>4 && docToAccessFiles_bil[4].content){
        var st = docToAccessFiles_bil[4].content.indexOf("/");
        var en = docToAccessFiles_bil[4].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[4].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[4].content.substring(startIndex+8, docToAccessFiles_bil[4].content.length)
        jsonPOSTdata.data[0][190] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[4].name,
            "data": tempFile
          }
        };
      }

      // Doc 6 //
      if (docToAccessFiles_bil.length>5 && docToAccessFiles_bil[5].content){
        var st = docToAccessFiles_bil[5].content.indexOf("/");
        var en = docToAccessFiles_bil[5].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[5].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[5].content.substring(startIndex+8, docToAccessFiles_bil[5].content.length)
        jsonPOSTdata.data[0][223] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[5].name,
            "data": tempFile
          }
        };
      }

      // Doc 7 //
      if (docToAccessFiles_bil.length>6 && docToAccessFiles_bil[6].content){
        var st = docToAccessFiles_bil[6].content.indexOf("/");
        var en = docToAccessFiles_bil[6].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[6].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[6].content.substring(startIndex+8, docToAccessFiles_bil[6].content.length)
        jsonPOSTdata.data[0][224] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[6].name,
            "data": tempFile
          }
        };
      }

      // Doc 8 //
      if (docToAccessFiles_bil.length>7 && docToAccessFiles_bil[7].content){
        var st = docToAccessFiles_bil[7].content.indexOf("/");
        var en = docToAccessFiles_bil[7].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[7].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[7].content.substring(startIndex+8, docToAccessFiles_bil[7].content.length)
        jsonPOSTdata.data[0][225] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[7].name,
            "data": tempFile
          }
        };
      }

      // Doc 9 //
      if (docToAccessFiles_bil.length>8 && docToAccessFiles_bil[8].content){
        var st = docToAccessFiles_bil[8].content.indexOf("/");
        var en = docToAccessFiles_bil[8].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[8].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[8].content.substring(startIndex+8, docToAccessFiles_bil[8].content.length)
        jsonPOSTdata.data[0][226] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[8].name,
            "data": tempFile
          }
        };
      }

      // Doc 10 //
      if (docToAccessFiles_bil.length>9 && docToAccessFiles_bil[9].content){
        var st = docToAccessFiles_bil[9].content.indexOf("/");
        var en = docToAccessFiles_bil[9].content.indexOf(";");
        var startIndex = docToAccessFiles_bil[9].content.indexOf(";base64,");
        let tempFile = docToAccessFiles_bil[9].content.substring(startIndex+8, docToAccessFiles_bil[9].content.length)
        jsonPOSTdata.data[0][227] = {
          "value": {
            "fileName": FILE_PREFIX + docToAccessFiles_bil[9].name,
            "data": tempFile
          }
        };
      }
      /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /*}
    else{
      alert("No files to attach")
      delete jsonPOSTdata.data[0][186];
      delete jsonPOSTdata.data[0][187];
      delete jsonPOSTdata.data[0][188];
      delete jsonPOSTdata.data[0][189];
      delete jsonPOSTdata.data[0][190];
      delete jsonPOSTdata.data[0][223];
      delete jsonPOSTdata.data[0][224];
      delete jsonPOSTdata.data[0][225];
      delete jsonPOSTdata.data[0][226];
      delete jsonPOSTdata.data[0][227];
    }*/

    
    // Potential Additionals
    
    
    

    // Consent to Eval
    if (assessmentState.consentToEvalAttached_bill && consentToEvalAttachedFiles_bil.length>0 && consentToEvalAttachedFiles_bil[0].content){
      var st = consentToEvalAttachedFiles_bil[0].content.indexOf("/");
      var en = consentToEvalAttachedFiles_bil[0].content.indexOf(";");
      var startIndex = consentToEvalAttachedFiles_bil[0].content.indexOf(";base64,");
      let tempFile = consentToEvalAttachedFiles_bil[0].content.substring(startIndex+8, consentToEvalAttachedFiles_bil[0].content.length)
      jsonPOSTdata.data[0][207] = {
        "value": {
          "fileName": FILE_PREFIX + consentToEvalAttachedFiles_bil[0].name,
          "data": tempFile
        }
      };
    }
    if (assessmentState.consentToEvalAttached_bill && consentToEvalAttachedFiles_bil.length>1 && consentToEvalAttachedFiles_bil[1].content){
      var st = consentToEvalAttachedFiles_bil[1].content.indexOf("/");
      var en = consentToEvalAttachedFiles_bil[1].content.indexOf(";");
      var startIndex = consentToEvalAttachedFiles_bil[1].content.indexOf(";base64,");
      let tempFile = consentToEvalAttachedFiles_bil[1].content.substring(startIndex+8, consentToEvalAttachedFiles_bil[1].content.length)
      jsonPOSTdata.data[0][240] = {
        "value": {
          "fileName": FILE_PREFIX + consentToEvalAttachedFiles_bil[1].name,
          "data": tempFile
        }
      };
    }
    
    // Prior Written notice
    if (assessmentState.priorWrittenNoticeAttached_bil && priorWrittenNoticeAttachedFiles_bil.length>0 && priorWrittenNoticeAttachedFiles_bil[0].content){
      var st = priorWrittenNoticeAttachedFiles_bil[0].content.indexOf("/");
      var en = priorWrittenNoticeAttachedFiles_bil[0].content.indexOf(";");
      var startIndex = priorWrittenNoticeAttachedFiles_bil[0].content.indexOf(";base64,");
      let tempFile = priorWrittenNoticeAttachedFiles_bil[0].content.substring(startIndex+8, priorWrittenNoticeAttachedFiles_bil[0].content.length)
      jsonPOSTdata.data[0][208] = {
        "value": {
          "fileName": FILE_PREFIX + priorWrittenNoticeAttachedFiles_bil[0].name,
          "data": tempFile
        }
      };
    }
    if (assessmentState.priorWrittenNoticeAttached_bil && priorWrittenNoticeAttachedFiles_bil.length>1 && priorWrittenNoticeAttachedFiles_bil[1].content){
      var st = priorWrittenNoticeAttachedFiles_bil[1].content.indexOf("/");
      var en = priorWrittenNoticeAttachedFiles_bil[1].content.indexOf(";");
      var startIndex = priorWrittenNoticeAttachedFiles_bil[1].content.indexOf(";base64,");
      let tempFile = priorWrittenNoticeAttachedFiles_bil[1].content.substring(startIndex+8, priorWrittenNoticeAttachedFiles_bil[1].content.length)
      jsonPOSTdata.data[0][242] = {
        "value": {
          "fileName": FILE_PREFIX + priorWrittenNoticeAttachedFiles_bil[1].name,
          "data": tempFile
        }
      };
    }
    
    // Home Lang Quest
    if (assessmentState.homeLangQuestAttached_bil && homeLangQuestAttachedFiles_bil.length>0 && homeLangQuestAttachedFiles_bil[0].content){
      var st = homeLangQuestAttachedFiles_bil[0].content.indexOf("/");
      var en = homeLangQuestAttachedFiles_bil[0].content.indexOf(";");
      var startIndex = homeLangQuestAttachedFiles_bil[0].content.indexOf(";base64,");
      let tempFile = homeLangQuestAttachedFiles_bil[0].content.substring(startIndex+8, homeLangQuestAttachedFiles_bil[0].content.length)
      jsonPOSTdata.data[0][209] = {
        "value": {
          "fileName": FILE_PREFIX + homeLangQuestAttachedFiles_bil[0].name,
          "data": tempFile
        }
      };
    }
    if (assessmentState.homeLangQuestAttached_bil && homeLangQuestAttachedFiles_bil.length>1 && homeLangQuestAttachedFiles_bil[1].content){
      var st = homeLangQuestAttachedFiles_bil[1].content.indexOf("/");
      var en = homeLangQuestAttachedFiles_bil[1].content.indexOf(";");
      var startIndex = homeLangQuestAttachedFiles_bil[1].content.indexOf(";base64,");
      let tempFile = homeLangQuestAttachedFiles_bil[1].content.substring(startIndex+8, homeLangQuestAttachedFiles_bil[1].content.length)
      jsonPOSTdata.data[0][241] = {
        "value": {
          "fileName": FILE_PREFIX + homeLangQuestAttachedFiles_bil[1].name,
          "data": tempFile
        }
      };
    }
    // Send the data
    getDataAxios();

  }

  const setProgressBarDataInParent = () => {
    let temp = 0;
    let allFilledOut = true;
    //alert(intakeFile)
    if (consentAttach == "1" || priorWrittenAttach == "1" || howLangAttach == "1"){
      /*
      console.log("consentAttach: " + consentAttach)
      console.log("priorWrittenAttach: " + priorWrittenAttach)
      console.log("howLangAttach: " + howLangAttach)
      console.log("consentToEvalAttachedFiles_bil " +consentToEvalAttachedFiles_bil[0]);
      console.log("consentToEvalAttachedFiles_bil CONTENT: " + consentToEvalAttachedFiles_bil[0]);
      console.log("priorWrittenNoticeAttachedFiles_bil " +priorWrittenNoticeAttachedFiles_bil.length);
      console.log("priorWrittenNoticeAttachedFiles_bil " +priorWrittenNoticeAttachedFiles_bil[0]);
      console.log("homeLangQuestAttachedFiles_bil " +homeLangQuestAttachedFiles_bil.length);
      console.log("homeLangQuestAttachedFiles_bil " +homeLangQuestAttachedFiles_bil[0]);
      */

      let noConsentFile = false;
      try{
        if(consentToEvalAttachedFiles_bil[0].name === "undefined" || consentToEvalAttachedFiles_bil[0].name === undefined) noConsentFile = true;
        else noConsentFile = false;
      }
      catch {noConsentFile = true}

      let noPriorWrittenAttach = false;
      try{
        if(priorWrittenNoticeAttachedFiles_bil[0].name === "undefined" || priorWrittenNoticeAttachedFiles_bil[0].name === undefined) noPriorWrittenAttach = true;
        else noPriorWrittenAttach = false;
      }
      catch {noPriorWrittenAttach = true}

      let noHowLangAttach = false;
      try{
        if(homeLangQuestAttachedFiles_bil[0].name === "undefined" || homeLangQuestAttachedFiles_bil[0].name === undefined) noHowLangAttach = true;
        else noHowLangAttach = false;
      }
      catch {noHowLangAttach = true}
      // No longer required
      temp += 50;
      if (consentAttach == "1")
      {
        if (!noConsentFile) temp += 17;
        else allFilledOut = false;
      }
      else temp += 17;
      if (priorWrittenAttach == "1")
      {
        if (!noPriorWrittenAttach) temp += 17;
        else allFilledOut = false;
      }
      else temp += 17;
      if (howLangAttach == "1")
      {
        if (!noHowLangAttach) temp += 16;
        else allFilledOut = false;
      }
      else temp += 16;
    }
    else{
      //if (intakeFile != "" && intakeFile != undefined) temp += 100;
      //if (dataForQB.docToAccessFiles_bil.length > 0) temp += 100;
      //else allFilledOut = false;
      //alert("NO EXTRA DOCS")
      // Bilingual Assessment file is no longer required
      temp += 100;
    }
    
    setColumn1Complete(allFilledOut)
    //alert("SET PROGESS BAR DATA IN PARENT TEMP: " + temp)
    handleProgressBarChange(parseInt(temp))
  }

  const updateColumn1Count = (valueInInput) => {

    let allFilledOut = true;
    //alert(intakeFile)
    if (consentAttach == "1" || priorWrittenAttach == "1" || howLangAttach == "1"){
      let noConsentFile = false;
      try{
        if(consentToEvalAttachedFiles_bil[0].name === "undefined" || consentToEvalAttachedFiles_bil[0].name === undefined) noConsentFile = true;
        else noConsentFile = false;
      }
      catch {noConsentFile = true}

      let noPriorWrittenAttach = false;
      try{
        if(priorWrittenNoticeAttachedFiles_bil[0].name === "undefined" || priorWrittenNoticeAttachedFiles_bil[0].name === undefined) noPriorWrittenAttach = true;
        else noPriorWrittenAttach = false;
      }
      catch {noPriorWrittenAttach = true}

      let noHowLangAttach = false;
      try{
        if(homeLangQuestAttachedFiles_bil[0].name === "undefined" || homeLangQuestAttachedFiles_bil[0].name === undefined) noHowLangAttach = true;
        else noHowLangAttach = false;
      }
      catch {noHowLangAttach = true}

      if (consentAttach == "1")
      {
        if (!noConsentFile) {}
        else allFilledOut = false;
      }
      if (priorWrittenAttach == "1")
      {
        if (!noPriorWrittenAttach) {}
        else allFilledOut = false;
      }
      if (howLangAttach == "1")
      {
        if (!noHowLangAttach) {}
        else allFilledOut = false;
      }
    }
    else{
    }
    setColumn1Complete(allFilledOut)

    setDocToAccessFiles_bilRunOut(docToAccessFiles_bilRunOut+1);

    setProgressBarDataInParent();
  }

  const updateConsentToEvalFields = (valueInInput) => {
    console.log("updateConsentToEvalFields val:")
    console.log(valueInInput)
    //alert("props.triggerUpdateFromParent/updateColumn1Count val: " + valueInInput)
    //setIntakeFile(valueInInput)
    setConsentToEvalAttachedFiles_bil(valueInInput);
    dataForQB.consentToEvalAttachedFiles_bil = valueInInput;

    //if (dataForQB.docToAccessFiles_bil.length > 0) setColumn1Complete(true)
    //else setColumn1Complete(false)

    setDocToAccessFiles_bilRunOut(docToAccessFiles_bilRunOut+1);

    setProgressBarDataInParent();
  }

  const updatePriorWrittenNoticeFiles = (valueInInput) => {
    setPriorWrittenNoticeAttachedFiles_bil(valueInInput);
    dataForQB.priorWrittenNoticeAttachedFiles_bil = valueInInput;
    setDocToAccessFiles_bilRunOut(docToAccessFiles_bilRunOut+1);
    setProgressBarDataInParent();
  }

  const updateHomeLangQuestFiles = (valueInInput) => {
    setHomeLangQuestAttachedFiles_bil(valueInInput);
    dataForQB.homeLangQuestAttachedFiles_bil = valueInInput;
    setDocToAccessFiles_bilRunOut(docToAccessFiles_bilRunOut+1);
    setProgressBarDataInParent();
  }

  const setDocToAccessFiles_bil_Helper = (valueInField) =>{
    console.log("setDocToAccessFiles_bil_Helper val:")
    console.log(valueInField)
    setDocToAccessFiles_bil(valueInField);
    dataForQB.docToAccessFiles_bil = valueInField;
    //if (dataForQB.docToAccessFiles_bil.length > 0) setColumn1Complete(true)
    //else setColumn1Complete(false)
    setDocToAccessFiles_bilRunOut(docToAccessFiles_bilRunOut+1)
    setProgressBarDataInParent();
  }


  if (!dataForQB.assessmentApprovalRunOnce){
    
    setTimeout(function(){
      dataForQB.assessmentApprovalRunOnce = true;
      //updateColumn1Count();
      //updateColumn2Count();
      //alert("RUNNNING")
      //setProgressBarDataInParent();
      updateColumn1Count(dataForQB.docToAccessFiles_bil);
      //dataForQB.assessmentApprovalRunOnce = true;
    },1000)
  }
  //else alert("ONCE: " + dataForQB.assessmentApprovalRunOnce)

 

  const handleThisContinueButton = function (newState) {
    handleContinueButton(newState)
  }

  function backToPreviousScreen(){
    dataForQB.assessmentRunOnce = false
    dataForQB.assessmentApprovalRunOnce = false
    handleThisContinueButton("assessmentPage3")
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setProgressBarDataInParent();
      console.log(column1Complete);
    }, 300);
    return () => clearTimeout(timer);
  }, [docToAccessFiles_bil, docToAccessFiles_bilRunOut, consentToEvalAttachedFile, priorWrittenNoticeAttachedFile, homeLangQuestAttachedFile]);

  function resetJSON(){
    dataForQB.translationTypes = [];
    dataForQB.iepText = '';
    dataForQB.iep_checked = '';
    dataForQB.transcriptText = '';
    dataForQB.transcript_checked = '';
    dataForQB.letterText = '';
    dataForQB.letter_checked = '';
    dataForQB.schoolDocumentText = '';
    dataForQB.schoolDocument_checked = '';
    dataForQB.calendarText = '';
    dataForQB.calendar_checked = '';
    dataForQB.flyerText = '';
    dataForQB.flyer_checked = '';
    dataForQB.handbookText = '';
    dataForQB.handbook_checked = '';
    dataForQB.healthFormsText = '';
    dataForQB.healthForms_checked = '';
    dataForQB.permissionSlipText = '';
    dataForQB.permissionSlip_checked = '';
    dataForQB.schedulesText = '';
    dataForQB.schedules_checked = '';
    dataForQB.evaluationsText = '';
    dataForQB.evaluations_checked = '';
    dataForQB.psychological_checked = '';
    dataForQB.educational_checked = '';
    dataForQB.socialHistory_checked = '';
    dataForQB.speechLanguage_checked = '';
    dataForQB.otherLanguageText = '';
    dataForQB.other_checked = '';
    dataForQB.otherText = '';
    dataForQB.dueDateText = '';
    dataForQB.dueTime_int = '';
    dataForQB.districtDropdown = '';
    dataForQB.districtRid = 0;
    dataForQB.schoolDropdown = '';
    dataForQB.schoolRid = 0;
    dataForQB.languageDropdown = '';
    dataForQB.contactNameText = '';
    dataForQB.contactPhoneText = '';
    dataForQB.contactEmailText = '';
    dataForQB.approverNameText = '';
    dataForQB.approverPositionText = '';
    dataForQB.approverEmailText = '';
    dataForQB.intakeRunOnce = false;
    dataForQB.dueDate_int = '';
    dataForQB.interpretationTypes_int = [];
    dataForQB.estimatedDurationHrs_int = '';
    dataForQB.estimatedDurationMins_int = '';
    dataForQB.paperWorkChecked_int = '';
    dataForQB.needInterpreterChecked_int = '';
    dataForQB.inPersonMeetingChecked_int = '';
    dataForQB.onlineOrVirtChecked_int = '';
    dataForQB.onlineMeetingLink_int = '';
    dataForQB.studentName_int = '';
    dataForQB.phone_int = '';
    dataForQB.grade_int = '';
    dataForQB.gender_int = '';
    dataForQB.languageDropdown_int = '';
    dataForQB.otherLanguages_int = '';
    dataForQB.districtDropdown_int = 0;
    dataForQB.schoolDropdown_int = 0;
    dataForQB.address_int = '';
    dataForQB.contactName_int = '';
    dataForQB.contactPhone_int = '';
    dataForQB.contactEmail_int = '';
    dataForQB.approverName_int = '';
    dataForQB.approverPosition_int = '';
    dataForQB.approverEmail_int = '';
    dataForQB.districtRid_int = 0;
    dataForQB.schoolRid_int = 0;
    dataForQB.approverSignatureFile_int = '';
    dataForQB.tableData_int = [];
    dataForQB.assessmentRunOnce = false;
    dataForQB.assessmentApprovalRunOnce = false;
    dataForQB.studentFirstName_bil = '';
    dataForQB.studentLastName_bil = '';
    dataForQB.countryOfOrigin_bil = '';
    dataForQB.DOB_bil = '';
    dataForQB.gender_bil = '';
    dataForQB.yearsInUS_bil = '';
    dataForQB.grade_bil = '';
    dataForQB.childResidesWith_bil = '';
    dataForQB.mfg1_bil = '';
    dataForQB.mfgName1_bil = '';
    dataForQB.mfg2_bil = '';
    dataForQB.mfgName2_bil = '';
    dataForQB.childsResidesWithOther_bil = '';
    dataForQB.homeAddress_bil = '';
    dataForQB.homeNum_bil = '';
    dataForQB.workNum_bil = '';
    dataForQB.cellNum_bil = '';
    dataForQB.nativeLanguage_bil = '';
    dataForQB.nativeLanguageOther_bil = '';
    dataForQB.districtDropdown_bil = '';
    dataForQB.schoolDropdown_bil = '';
    dataForQB.CSEDate_bil = '';
    dataForQB.psychologistName_bil = '';
    dataForQB.psychologistEmail_bil = '';
    dataForQB.speechPathologistName_bil = '';
    dataForQB.speechPathologistEmail_bil = '';
    dataForQB.districtContactName_bil = '';
    dataForQB.districtContactTitle_bil = '';
    dataForQB.districtContactAddress_bil = '';
    dataForQB.districtContactPhone_bil = '';
    dataForQB.districtContactEmail_bil = '';
    dataForQB.reason_bil = '';
    dataForQB.alreadyClassified_bil = '';
    dataForQB.classification_bil = '';
    dataForQB.consentToEvalAttached_bill = false;
    dataForQB.priorWrittenNoticeAttached_bil = false;
    dataForQB.homeLangQuestAttached_bil = false;
    dataForQB.nonVerbSecDiagnosed_bil = false;
    dataForQB.studentEnterSchoolDate_bil = '';
    dataForQB.nameOfOtherSchoolAttended_bil = '';
    dataForQB.typesOfEvals_bil = [];
    dataForQB.diagnosedCondition_bil = '';
    dataForQB.diagnosedConditionText_bil = '';
    dataForQB.services_bil = [];
    dataForQB.generalHealth_bil = false;
    dataForQB.generalHealthText_bil = '';
    dataForQB.medication_bil = false;
    dataForQB.medicationText_bil = '';
    dataForQB.wearsGlasses_bil = false;
    dataForQB.wearsGlassesText_bil = '';
    dataForQB.pedRestrictions_bil = false;
    dataForQB.pedRestrictionsText_bil = '';
    dataForQB.physicalExamDate_bil = '';
    dataForQB.h_freq_audiology_bil = '';
    dataForQB.h_indv_audiology_bil = '';
    dataForQB.h_freq_visTherapy_bil = '';
    dataForQB.h_indv_visTherapy_bil = '';
    dataForQB.h_freq_resourceRoom_bil = '';
    dataForQB.h_indv_resourceRoom_bil = '';
    dataForQB.h_freq_counseling_bil = '';
    dataForQB.h_indv_counseling_bil = '';
    dataForQB.h_freq_speechLang_bil = '';
    dataForQB.h_indv_speechLang_bil = '';
    dataForQB.h_freq_physTherapy_bil = '';
    dataForQB.h_indv_physTherapy_bil = '';
    dataForQB.h_freq_occTherapy_bil = '';
    dataForQB.h_indv_occTherapy_bil = '';
    dataForQB.i_freq_Reading_bil = '';
    dataForQB.i_indv_Reading_bil = '';
    dataForQB.i_freq_AISMath_bil = '';
    dataForQB.i_indv_AISMath_bil = '';
    dataForQB.i_freq_AAtL_bil = '';
    dataForQB.i_indv_AAtL_bil = '';
    dataForQB.i_freq_AdjAssign_bil = '';
    dataForQB.i_indv_AdjAssign_bil = '';
    dataForQB.i_freq_schedAdj_bil = '';
    dataForQB.i_indv_schedAdj_bil = '';
    dataForQB.i_freq_indvProgBasedOnSkill_bil = '';
    dataForQB.i_indv_indvProgBasedOnSkill_bil = '';
    dataForQB.i_freq_speechImprov_bil = '';
    dataForQB.i_indv_speechImprov_bil = '';
    dataForQB.i_freq_tutoring_bil = '';
    dataForQB.i_indv_tutoring_bil = '';
    dataForQB.i_freq_consulServices_bil = '';
    dataForQB.i_indv_consulServices_bil = '';
    dataForQB.i_other_bil = '';
    dataForQB.areas_bil = [];
    dataForQB.addConcerns_bil = '';
    dataForQB.suspDetails_bil = '';
    dataForQB.docToTranslateFiles = [];
    dataForQB.docToInterperateFiles_int = [];
    dataForQB.docToAccessFiles_bil = [];
    dataForQB.consentToEvalAttachedFiles_bil = [];
    dataForQB.priorWrittenNoticeAttachedFiles_bil = [];
    dataForQB.homeLangQuestAttachedFiles_bil = [];
    dataForQB.notes_int = '';
    dataForQB.notes_bil = '';
    dataForQB.approverName_bil = '';
    dataForQB.approverTitle_bil = '';
    dataForQB.approverEmail_bil = '';
    dataForQB.teleconference_int = '';
    dataForQB.teleconferencePhone_int = '';
    dataForQB.currentTeacherName_bil = '';
    dataForQB.currentTeacherEmail_bil = '';
    dataForQB.coser_bil = '';

    dispatch(backToInitialValuesUpdated(translationState.backToInitialValues+1))
    dispatch(backToInitialValuesUpdated_int(interpretationState.backToInitialValues_int+1))
    dispatch(backToInitialValuesUpdated_bil(assessmentState.backToInitialValues_bil+1))
  }

  const renderColumn1ColumnStatus = () => {
    return <ColumnStatus complete={column1Complete} />
  }
  //////////////////////////////////////////////////////////////

  const progressBarData =
    { bgcolor: "#00695c", completed: 0 };

  const sendDatatoQB = () => {
    //alert("WTF")
    // First we'll set any checks based on if the field has data
    finalizeJSONAndCallAPS();
  
  }

  async function getDataAxios() {
      // Show loading
      setShowLoadingModal(true)
      //alert("SET SHOW LOADING MODAL")
      console.log("POST DATA")
      console.log(jsonPOSTdata)
    ///////////////////////////////////////////////////////////////////////////////
    // POST
    const response = await axios.post(
      'https://api.quickbase.com/v1/records',
      jsonPOSTdata,
      {
        headers: {
          'QB-Realm-Hostname': 'nassauboces.quickbase.com',
          'Authorization': 'QB-USER-TOKEN b3m32i_br69_0_c89ecind3d9jnncsv8a38b7gj33s'
        }
      }
    )
    .then((response) => {
      //setShowLoadingModal(false)
      setLoadingSnack("Your Bilingual Assessment has successfully processed!")
      setLoadingSnackClass("complete")
      console.log(response);
      
      //////////////////////////////////////////////////////////////////////////////////////
      // Sending the logs for any future debugging, slugging, or mugging
      //////////////////////////////////////////////////////////////////////////////////////
      DEBUG_RESPONSE = response.data;
      DEBUG_RESPOSNE_STATUS = response.status;
      debugDOdata.data[0][6].value=JSON.stringify(jsonPOSTdata);
      debugDOdata.data[0][11].value=JSON.stringify(DEBUG_RESPONSE);
      debugDOdata.data[0][8].value=DEBUG_RESPOSNE_STATUS;
      axios.post(
        'https://api.quickbase.com/v1/records',
        debugDOdata,
        {
          headers: {
            'QB-Realm-Hostname': 'nassauboces.quickbase.com',
            'Authorization': 'QB-USER-TOKEN b3m32i_br69_0_c89ecind3d9jnncsv8a38b7gj33s'
          }
        }
      ).then((response) => {
        // Show success for 3 seconds
        setTimeout(function () {
          resetJSON();
          setShowLoadingModal(false)
          setContentState('main')
          console.log("DEBUG LOG RESPONSE:")
          console.log(response);
        }, 4000)
      }, (error) => {
        // Show success for 3 seconds
        setTimeout(function () {
          resetJSON();
          setShowLoadingModal(false)
          setContentState('main')
          console.log("DEBUG LOG ERROR:")
          console.log(error)
        }, 4000)
      });
      //////////////////////////////////////////////////////////////////////////////////////
    }, (error) => {
      
      //setShowLoadingModal(false)
      setLoadingSnack("Sorry we are experiecing Technical Difficulties, try again later!")
      setLoadingSnackClass("error")
      // Show loading
      setShowLoadingModal(true)
      console.log("=========error===========")
      console.log(error);
      console.log("=========request===========")
      console.log(jsonPOSTdata)
      //alert("ERROR: " + error)
      /* START OF OLD
      // Show error for 3 seconds
      setTimeout(function () {
        resetJSON();
        setShowLoadingModal(false)
        setContentState('main')
      }, 5000)
      END OF OLD */
      //////////////////////////////////////////////////////////////////////////////////////
      // Sending the logs for any future debugging, slugging, or mugging
      //////////////////////////////////////////////////////////////////////////////////////
      DEBUG_RESPONSE = response.data;
      DEBUG_RESPOSNE_STATUS = response.status;
      debugDOdata.data[0][6].value=JSON.stringify(jsonPOSTdata);
      debugDOdata.data[0][11].value=JSON.stringify(DEBUG_RESPONSE);
      debugDOdata.data[0][8].value=DEBUG_RESPOSNE_STATUS;
      axios.post(
        'https://api.quickbase.com/v1/records',
        debugDOdata,
        {
          headers: {
            'QB-Realm-Hostname': 'nassauboces.quickbase.com',
            'Authorization': 'QB-USER-TOKEN b3m32i_br69_0_c89ecind3d9jnncsv8a38b7gj33s'
          }
        }
      ).then((response) => {
        // Show success for 3 seconds
        setTimeout(function () {
          resetJSON();
          setShowLoadingModal(false)
          setContentState('main')
          console.log("DEBUG LOG RESPONSE:")
          console.log(response);
        }, 5000)
      }, (error) => {
        // Show success for 3 seconds
        setTimeout(function () {
          resetJSON();
          setShowLoadingModal(false)
          setContentState('main')
          console.log("DEBUG LOG ERROR:")
          console.log(error)
        }, 5000)
      });
      //////////////////////////////////////////////////////////////////////////////////////


    });
    /////////////////////////////////////////////////////////////////////////
    
  }

  return (
    <div>
      {/*<FadeIn delay={200} duration={450}>*/}
      <Container fluid className="">
                <Box style={{paddingTop: '15px', width: '40%', backgroundColor: '#F8F8F8', padding: '3px', marginBottom: '10px'}}>
                <Card variant="outlined" style={{padding: '10px',}}>
                  <CardContent>
        {/*<Row>
          <Col>{renderColumn1ColumnStatus()}</Col>
        </Row>*/}
        <Row>
          <Col>
            <h4 className="content-section-title">Bilingual Assessment File</h4>
            <h4 className="content-section-title-sm">(Optional)</h4>
          </Col>
        </Row>
        <Row><Col><p style={{lineHeight:'20%'}}>&nbsp;</p></Col></Row>
        <Row>
          <Col>
          <p style={{textAlign:'center'}}>
              <FadeIn delay={150} duration={450}>
                {/* Signature Upload */}
                <SignatureUpload id="formFile" 
                  classesToAdd={""} 
                  maxFiles={5}
                  valueInField={dataForQB.docToAccessFiles_bil} 
                  triggerUpdateFromParent={setDocToAccessFiles_bil_Helper} 
                  required={true} />{/* Form Upload */}
              </FadeIn>
            </p>
            </Col>
        </Row>

        </CardContent>
        </Card>
        </Box>
        
          <Box style={{width: '40%', backgroundColor: '#F8F8F8', padding: '3px', marginBottom: '10px'}}>
          <Card variant="outlined" style={{padding: '10px',}}>
           <CardContent>
          <Row>
          <Col>
            <h4 className="content-section-title">Additional Student Information/Document(s)</h4>
            {
            assessmentState.consentToEvalAttached_bill || assessmentState.priorWrittenNoticeAttached_bil == "1" || assessmentState.homeLangQuestAttached_bil == "1" ? <h4 className="content-section-title-sm">(Required)</h4>
            :
            <h4 className="content-section-title-sm">(You have not selected any additional documents in the previous step)</h4>
            }
          </Col>
        </Row>
        <Row><Col><br /></Col></Row>


        <Row>
          <Col>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
              <FadeIn style={{width:'100%'}} delay={150} duration={450}>
                {/* Signature Upload */}
                {
                 assessmentState.consentToEvalAttached_bill && <><p style={{textAlign:'center', fontWeight:'bold', lineHeight: "20%"}}>Consent To Eval Doc:</p><p style={{textAlign:"center",}}><SignatureUpload id="consentAttach" classesToAdd={"required"} maxFiles={2} valueInField={dataForQB.consentToEvalAttachedFiles_bil}  triggerUpdateFromParent={updateConsentToEvalFields} required={false} /></p></>
                }
                {
                 assessmentState.priorWrittenNoticeAttached_bil && <><p style={{paddingTop: '10px',clear:'both',textAlign: 'center', fontWeight:'bold', lineHeight: "20%"}}>Prior Written Notice Doc:</p><p style={{textAlign:"center"}}><SignatureUpload id="priorWrittenAttach" classesToAdd={"required"} maxFiles={2} valueInField={dataForQB.priorWrittenNoticeAttachedFiles_bil}  triggerUpdateFromParent={updatePriorWrittenNoticeFiles} required={false} /></p></>
                }
                {
                 assessmentState.homeLangQuestAttached_bil && <><p style={{paddingTop: '10px',clear:'both',textAlign: 'center', fontWeight:'bold', lineHeight: "20%"}}>Home Language Doc:</p><p style={{textAlign:"center"}}><SignatureUpload id="homeLangAttach" classesToAdd={"required"} maxFiles={2} valueInField={dataForQB.homeLangQuestAttachedFiles_bil}  triggerUpdateFromParent={updateHomeLangQuestFiles} required={false} /></p></>
                }
                
              </FadeIn>
            </div>
          </Col>
        </Row>

        </CardContent>
</Card>
        </Box>

        <Row>
                    <Col>
                    <div className='form-button-bottom-container' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', width: '40%' }}>
                    <Button className="btn btn-primary form-button-bottom" onClick={sendDatatoQB} disabled={!showSaveBtn}
                        variant="contained" color="primary">
                        Submit Assessment
                      </Button>
                      </div>
                    </Col>
                  </Row>
      </Container>

      <div className="form-button-bottom-container">
        {/*<Button className="btn btn-primary form-button-bottom" onClick={() => backToPreviousScreen()} disabled={false}
          variant="contained" color="primary">
          Back
        </Button>
        &nbsp;&nbsp;&nbsp;&nbsp;*/}
      </div>
      <br/><br/>

      <Modal_Loading subClass={loadingSnackClass} text={loadingSnack} show={showLoadingModal} />
      {/*</FadeIn>*/}
    </div>
  )
}

export default ApprovalContent_Assessments